export default {
  setState: (state, { key, value }) => {
    state[key] = value;
  },
};
